// extracted by mini-css-extract-plugin
module.exports = {"container":"fx-z","copyContainer":"gx-z"};